import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  FaArrowRight,
  FaArrowLeft,
  FaPlay,
  FaPause,
} from "react-icons/fa";

const cx = (...c) => c.filter(Boolean).join(" ");

const Diaporama = () => {
  const images = useMemo(
    () => [
      { src: "/images/diapo_mac/screen001.webp", alt: "Page Accueil Header", caption: "Page Accueil Header" },
      { src: "/images/diapo_mac/screen002.webp", alt: "Menu par rôles", caption: "Menu par rôles" },
      { src: "/images/diapo_mac/screen003.webp", alt: "Informations et présentation Club", caption: "Informations et présentation Club" },
      { src: "/images/diapo_mac/screen004.webp", alt: "Diaporama et Disciplines enseignées", caption: "Diaporama et Disciplines enseignées" },
      { src: "/images/diapo_mac/screen005.webp", alt: "Dojo, Groupes, Horaires & Tarifs", caption: "Dojo, Groupes, Horaires & Tarifs" },
      { src: "/images/diapo_mac/screen006.webp", alt: "Planning des Cours", caption: "Planning des Cours" },
      { src: "/images/diapo_mac/screen007.webp", alt: "Vidéo & Présentation des équipes", caption: "Vidéo & Présentation des équipes" },
      { src: "/images/diapo_mac/screen008.webp", alt: "Statistiques adhérents", caption: "Statistiques adhérents" },
      { src: "/images/diapo_mac/screen009.webp", alt: "Prochaines compétitions & Dernières Actualités", caption: "Prochaines compétitions & Dernières Actualités" },
      { src: "/images/diapo_mac/screen010.webp", alt: "Derniers Palmarès et Albums Photos", caption: "Derniers Palmarès et Albums Photos" },
      { src: "/images/diapo_mac/screen011.webp", alt: "Les ceintures du club", caption: "Les ceintures du club" },
      { src: "/images/diapo_mac/screen012.webp", alt: "Partenaires & Formulaire de contact", caption: "Partenaires & Formulaire de contact" },
      { src: "/images/diapo_mac/screen013.webp", alt: "Tableau de bord Utilisateur", caption: "Tableau de bord Utilisateur" },
      { src: "/images/diapo_mac/screen014.webp", alt: "Dossier d'Inscription Utilisateur", caption: "Dossier d'Inscription Utilisateur" },
      { src: "/images/diapo_mac/screen015.webp", alt: "Fiche Adhérent", caption: "Fiche Adhérent" },
      { src: "/images/diapo_mac/screen016.webp", alt: "Signaler une absence", caption: "Signaler une absence" },
      { src: "/images/diapo_mac/screen017.webp", alt: "Calendrier des Compétitions", caption: "Calendrier des Compétitions" },
      { src: "/images/diapo_mac/screen018.webp", alt: "Détails Compétition", caption: "Détails Compétition" },
      { src: "/images/diapo_mac/screen019.webp", alt: "Messagerie", caption: "Messagerie" },
      { src: "/images/diapo_mac/screen020.webp", alt: "Boutique en ligne", caption: "Boutique en ligne" },
      { src: "/images/diapo_mac/screen021.webp", alt: "Commandes & Règlements", caption: "Commandes & Règlements" },
      { src: "/images/diapo_mac/screen022.webp", alt: "Actualités", caption: "Actualités" },
      { src: "/images/diapo_mac/screen023.webp", alt: "Préparation Physique", caption: "Préparation Physique" },
      { src: "/images/diapo_mac/screen024.webp", alt: "Albums Photos", caption: "Albums Photos" },
      { src: "/images/diapo_mac/screen025.webp", alt: "Lexique", caption: "Lexique" },
      { src: "/images/diapo_mac/screen026.webp", alt: "Arbitrage", caption: "Arbitrage" },
      { src: "/images/diapo_mac/screen027.webp", alt: "Révisions Techniques", caption: "Révisions Techniques" },
      { src: "/images/diapo_mac/screen028.webp", alt: "Listing Adhérents pour Enseignants", caption: "Listing Adhérents pour Enseignants" },
      { src: "/images/diapo_mac/screen029.webp", alt: "Gestion des Présences", caption: "Gestion des Présences" },
      { src: "/images/diapo_mac/screen030.webp", alt: "Statistiques de Présences", caption: "Statistiques de Présences" },
      { src: "/images/diapo_mac/screen031.webp", alt: "Passages de Grades", caption: "Passages de Grades" },
      { src: "/images/diapo_mac/screen032.webp", alt: "Passage Ceintures Noires", caption: "Passage Ceintures Noires" },
      { src: "/images/diapo_mac/screen033.webp", alt: "Gestion du Calendrier des Compétitions", caption: "Gestion du Calendrier des Compétitions" },
      { src: "/images/diapo_mac/screen034.webp", alt: "Suivi des Inscriptions aux compétitions", caption: "Suivi des Inscriptions aux compétitions" },
      { src: "/images/diapo_mac/screen035.webp", alt: "Palmarès des adhérents", caption: "Palmarès des adhérents" },
      { src: "/images/diapo_mac/screen036.webp", alt: "Objectifs des adhérents sur la saison", caption: "Objectifs des adhérents sur la saison" },
      { src: "/images/diapo_mac/screen037.webp", alt: "ToDoList", caption: "ToDoList" },
      { src: "/images/diapo_mac/screen038.webp", alt: "Gestion des Techniques", caption: "Gestion des Techniques" },
      { src: "/images/diapo_mac/screen039.webp", alt: "Répatition des adhérents par catégorie d'âge et de poids", caption: "Répatition des adhérents par catégorie d'âge et de poids" },
      { src: "/images/diapo_mac/screen040.webp", alt: "Aide & Tuto pour Enseignants", caption: "Aide & Tuto pour Enseignants" },
      { src: "/images/diapo_mac/screen041.webp", alt: "Statistiques Adhérents", caption: "Statistiques Adhérents" },
      { src: "/images/diapo_mac/screen042.webp", alt: "Statistiques Comptabilité", caption: "Statistiques Comptabilité" },
      { src: "/images/diapo_mac/screen043.webp", alt: "Fiche Adhérents pour Administrateurs", caption: "Fiche Adhérents pour Administrateurs" },
      { src: "/images/diapo_mac/screen044.webp", alt: "Listing Utilisateurs et Rôles", caption: "Listing Utilisateurs et Rôles" },
      { src: "/images/diapo_mac/screen045.webp", alt: "Listing des Adhérents", caption: "Listing des Adhérents" },
      { src: "/images/diapo_mac/screen046.webp", alt: "Règlements Licences-Cotisations", caption: "Règlements Licences-Cotisations" },
      { src: "/images/diapo_mac/screen047.webp", alt: "Gestion des Dossiers d'Inscriptions", caption: "Gestion des Dossiers d'Inscriptions" },
      { src: "/images/diapo_mac/screen048.webp", alt: "Gestion des Commandes & Règlements", caption: "Gestion des Commandes & Règlements" },
      { src: "/images/diapo_mac/screen049.webp", alt: "Gestion des Articles Boutique", caption: "Gestion des Articles Boutique" },
      { src: "/images/diapo_mac/screen050.webp", alt: "Dépenses-Recettes du Club", caption: "Dépenses-Recettes du Club" },
      { src: "/images/diapo_mac/screen051.webp", alt: "Suivi des heures de coaching et enseignement", caption: "Suivi des heures de coaching et enseignement" },
      { src: "/images/diapo_mac/screen052.webp", alt: "Gestion des stocks et prêts de matériels", caption: "Gestion des stocks et prêts de matériels" },
      { src: "/images/diapo_mac/screen053.webp", alt: "Gestion des Votes & Sondages", caption: "Gestion des Votes & Sondages" },
      { src: "/images/diapo_mac/screen054.webp", alt: "Paramètres et Personnalisation du Site", caption: "Paramètres et Personnalisation du Site" },
    ],
    []
  );

  const [current, setCurrent] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const touch = useRef({ x: 0, y: 0, active: false });

  const next = () => setCurrent((p) => (p + 1) % images.length);
  const prev = () => setCurrent((p) => (p === 0 ? images.length - 1 : p - 1));

  useEffect(() => {
    const reduceMotion =
      window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    if (reduceMotion || !autoPlay) return;

    const t = setInterval(next, 5000);
    return () => clearInterval(t);
  }, [autoPlay, images.length]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const onTouchStart = (e) => {
    const t = e.touches?.[0];
    if (!t) return;
    touch.current = { x: t.clientX, y: t.clientY, active: true };
  };

  const onTouchEnd = (e) => {
    if (!touch.current.active) return;
    const t = e.changedTouches?.[0];
    if (!t) return;

    const dx = t.clientX - touch.current.x;
    const dy = t.clientY - touch.current.y;
    touch.current.active = false;

    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
      dx < 0 ? next() : prev();
    }
  };

  const item = images[current];

  return (
    <section className="bg-slate-50 py-16 sm:py-20 dark:bg-slate-900/40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-3xl">
          <div className="text-sm font-semibold uppercase tracking-[0.18em] text-sky-500">
            Aperçus
          </div>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-5xl dark:text-white">
            Quelques écrans pour visualiser l’expérience
          </h2>
          <p className="mt-4 text-base leading-8 text-slate-600 sm:text-lg dark:text-slate-300">
            Une sélection de pages pour voir l’interface côté adhérents,
            enseignants et bureau.
          </p>
        </div>

        <div className="mt-10 rounded-[32px] border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-slate-900 sm:p-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <div className="text-lg font-semibold text-slate-900 dark:text-white">
                {item.caption}
              </div>
              <div className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                {current + 1} / {images.length}
              </div>
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={prev}
                className="grid h-11 w-11 place-items-center rounded-full border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 dark:border-white/10 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                aria-label="Précédent"
              >
                <FaArrowLeft />
              </button>

              <button
                onClick={() => setAutoPlay((v) => !v)}
                className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 dark:border-white/10 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
              >
                {autoPlay ? <FaPause /> : <FaPlay />}
                {autoPlay ? "Pause" : "Auto"}
              </button>

              <button
                onClick={next}
                className="grid h-11 w-11 place-items-center rounded-full border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 dark:border-white/10 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                aria-label="Suivant"
              >
                <FaArrowRight />
              </button>
            </div>
          </div>

          <div
            className="mt-5 overflow-hidden rounded-[28px] border border-slate-200 bg-slate-50 dark:border-white/10 dark:bg-slate-950"
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
          >
            <img
              src={item.src}
              alt={item.alt}
              className="w-full object-cover"
              loading="lazy"
            />
          </div>

          <div className="mt-5">
            <div className="mb-3 text-sm font-semibold text-slate-900 dark:text-white">
              Accès direct
            </div>

            <div className="flex gap-3 overflow-x-auto pb-2">
              {images.map((img, i) => (
                <button
                  key={img.src}
                  onClick={() => setCurrent(i)}
                  className={cx(
                    "shrink-0 overflow-hidden rounded-2xl border transition",
                    i === current
                      ? "border-sky-500 ring-2 ring-sky-400/30"
                      : "border-slate-200 hover:border-sky-300 dark:border-white/10 dark:hover:border-sky-500/40"
                  )}
                  aria-label={`Aller à ${img.caption}`}
                  title={img.caption}
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="h-20 w-32 object-cover"
                    loading="lazy"
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Diaporama;